import type { DictionaryWord } from "@-/dev.improve.haniverse.lib.morpheme.word.read";
import { useActorUser } from "@-/dev.improve.haniverse.lib.user";
import {
  getHskLevelLabel,
  isHskLevelKey,
  type HskVersionKey,
} from "@-/dev.improve.haniverse.lib.morpheme.grade.hsk";
import { useMemo } from "react";

function resolveHskVersion(value: string): HskVersionKey {
  return value === "hsk2" || value === "hsk3" || value === "hsk2026" ? value : "hsk2026";
}

function wordHskLevelForVersion(
  word: Pick<DictionaryWord, "hsk2010Level" | "hsk2021Level" | "hsk2026Level">,
  hskVersion: HskVersionKey,
): number | null {
  switch (hskVersion) {
    case "hsk2": {
      return word.hsk2010Level;
    }
    case "hsk3": {
      return word.hsk2021Level;
    }
    case "hsk2026": {
      return word.hsk2026Level;
    }
  }
}

function formatHskLevel(level: number): string {
  return isHskLevelKey(level) ? getHskLevelLabel(level) : String(level);
}

export function useWordRowStatsLabels(word: DictionaryWord) {
  const { hanziScript, hskVersion: rawHskVersion } = useActorUser();
  const hskVersion = resolveHskVersion(rawHskVersion);

  const rankLabel = word.rank != null ? `#${word.rank}` : null;

  const levelLabel = useMemo(() => {
    if (hanziScript === "traditional") {
      if (word.tbclLevel === null) {
        return null;
      }
      return `TBCL ${word.tbclLevel}`;
    }
    const level = wordHskLevelForVersion(word, hskVersion);
    if (level === null) {
      return null;
    }
    return `HSK ${formatHskLevel(level)}`;
  }, [hanziScript, hskVersion, word]);

  return { levelLabel, rankLabel };
}
